var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.totalSteps)?_c('ol',{staticClass:"steps"},_vm._l((_vm.steps),function(step){return _c('li',{key:step,class:['step', { reached: step <= _vm.currentStep }]})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }